/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';

interface ProjectSelectorProps {
    projects: any[];
    selectedProject: string;
    onProjectChange: (projectId: string) => void;
}

const ProjectSelector: React.FC<ProjectSelectorProps> = ({
    projects,
    selectedProject,
    onProjectChange,
}) => {
    return (
        <div className="mb-6">
            <label className="block text-sm font-medium text-gray-300 mb-2">
                Select Project
            </label>
            <select
                value={selectedProject}
                onChange={(e) => onProjectChange(e.target.value)}
                className="input max-w-xs"
            >
                <option value="">Select a project</option>
                {projects.map((project: any) => (
                    <option key={project.id} value={project.id}>
                        {project.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ProjectSelector;
